import { Card } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { formatMinutes } from "../utils";

interface BarEntry {
  key: string;
  color: string;
}

interface BarDataItem {
  date: string;
  [key: string]: string | number;
}

interface ActivityChartProps {
  barData: BarDataItem[];
  breakdownKeys: BarEntry[];
}

const CustomBarTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div
      style={{
        background: "#1f1f1f",
        padding: "10px 14px",
        borderRadius: 4,
        color: "#fff",
        fontSize: 13,
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 6 }}>{label}</div>
      {payload.map((entry: any) => (
        <div
          key={entry.dataKey}
          style={{ display: "flex", justifyContent: "space-between", gap: 24 }}
        >
          <span style={{ color: entry.fill }}>● {entry.name}</span>
          <span>{formatMinutes(entry.value)}</span>
        </div>
      ))}
    </div>
  );
};

const ActivityChart = ({ barData, breakdownKeys }: ActivityChartProps) => (
  <Card bodyStyle={{ padding: "16px 8px" }} style={{ marginBottom: 16 }}>
    <ResponsiveContainer width="100%" height={280}>
      <BarChart
        data={barData}
        margin={{ top: 16, right: 16, left: 0, bottom: 0 }}
      >
        <XAxis dataKey="date" tick={{ fontSize: 11 }} />
        <YAxis
          tickFormatter={(v) => formatMinutes(v)}
          tick={{ fontSize: 11 }}
          width={55}
        />
        <Tooltip content={<CustomBarTooltip />} />
        {breakdownKeys.map((item) => (
          <Bar
            key={item.key}
            dataKey={item.key}
            stackId="a"
            fill={item.color}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  </Card>
);

export default ActivityChart;
